import { Container, Spinner } from "react-bootstrap";
import CompaniesTable from "../Tables/CompaniesTable/CompaniesTable";
import CustomPagination from "../CustomPagination/CustomPagination";
import { useSearchParams } from "react-router-dom";
import { useEffect, useRef, Dispatch, SetStateAction } from "react";
import { Company } from "components/molecules/LoyaltyProgramServiceArticle/types";
import { InitialSearchParamsType } from "components/templates/CompaniesAdminTemplate/CompaniesAdminTemplate";

interface Props {
  companiesData: { data: Company[]; meta: { totalResults: number } };
  currPage: number;
  setCurrPage: Dispatch<SetStateAction<number>>;
  isLoading: boolean;
  initialSearchParams: InitialSearchParamsType;
}

const CompaniesSection = ({
  companiesData,
  currPage,
  setCurrPage,
  isLoading,
  initialSearchParams,
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tableRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    //eslint-disable-next-line
  }, [currPage]);

  const handlePageChange = (page: number) => {
    searchParams.set("companiesPage", page.toString());
    setSearchParams(searchParams);
    setCurrPage(page);
  };

  return (
    <Container fluid className="p-2" ref={tableRef}>
      <h2 className="px-0 fs-1 lh-base fw-600 text-dark me-4 mb-4">
        Zarządzanie firmami
      </h2>
      {isLoading ? (
        <Container className={"d-flex justify-content-center"}>
          <Spinner animation="border" variant="primary" />
        </Container>
      ) : (
        <>
          <CompaniesTable data={companiesData?.data} />
          <CustomPagination
            totalCount={
              companiesData?.meta?.totalResults ||
              initialSearchParams.TOTAL_RESULTS
            }
            pageSize={initialSearchParams.LIMIT}
            currentPage={currPage}
            onPageChange={handlePageChange}
            paginationClassName="text-nowrap"
          />
        </>
      )}
    </Container>
  );
};

export default CompaniesSection;
